module.exports = __webpack_public_path__ + "img/f_b1_moonheel.6af6c95b.jpg";